<template>
  <div class="card border-0 shadow-none rounded-1 mb-30">
    <div class="card-body p-xl-40">
      <h6 class="fs-18 mb-35 text-title fw-semibold">
        {{ $t("purchase_page.selected_products_for_purchase") }}
      </h6>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ps-0 ls-1">
                {{ $t("purchase_page.product") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("purchase_page.code") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("purchase_page.unit_cost") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("purchase_page.stock") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("purchase_page.quantity") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("purchase_page.discount") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("purchase_page.tax") }}
              </th>
              <th scope="col" class="text-title fw-normal fs-14 pt-0 ls-1">
                {{ $t("purchase_page.subtotal") }}
              </th>
              <th
                scope="col"
                class="text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
              >
                {{ $t("purchase_page.delete") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, index) in products" :key="product.id">
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0">
                {{ product.name }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                {{ product.code }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $ {{ product.cost }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <span class="badge badge-success fw-semibold fs-14">
                  {{ product.qty }}
                </span>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <QuantityCounter v-model="product.quantity" @update:modelValue="updateSubtotal(index)" />
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                <div class="form-group mb-0">
                  <input
                    type="number"
                    v-model="product.discount"
                    @input="updateSubtotal(index)"
                    class="form-control form-control-sm text-center"
                    style="width: 80px;"
                  />
                </div>
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $ {{ product.tax }}
              </td>
              <td class="shadow-none lh-1 fs-14 fw-normal text-paragraph">
                $ {{ product.subTotal }}
              </td>
              <td class="shadow-none lh-1 text-end pe-0">
                <div
                  class="button-group style-two ms-auto d-flex flex-wrap align-items-center"
                >
                  <a
                    class="delete-btn cursor-pointer"
                    @click="$emit('remove', index)"
                    role="button"
                  >
                    <img
                      src="../../../assets/img/icons/close.svg"
                      alt="Image"
                    />
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import QuantityCounter from "./QuantityCounter.vue";

type SelectedProductRow = {
  id?: number;
  name?: string;
  code?: string;
  cost?: number | string;
  qty?: number;
  quantity?: number | string;
  discount?: number | string;
  tax?: number | string;
  subTotal?: string;
};

const toNumber = (value: unknown): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export default defineComponent({
  name: "SelectedProducts",
  components: {
    QuantityCounter,
  },
  props: {
    products: {
      type: Array as () => SelectedProductRow[],
      required: true,
    },
  },
  emits: ["remove"],
  setup(props) {
    const updateSubtotal = (index: number) => {
      const product = props.products[index];
      const cost = toNumber(product.cost);
      const qty = toNumber(product.quantity);
      const discount = toNumber(product.discount);
      const tax = toNumber(product.tax);
      
      product.subTotal = (cost * qty - discount + tax).toFixed(2);
    };

    return {
      updateSubtotal,
    };
  },
});
</script>
